module.exports = "https://venezia-network.servercdn.it/static/fonts/FuturaPT-Book.woff2?8cd2ddc4f8da5b39b5736f3d5025a640";